import { limitWordsAndSpaces } from './limitWordsAndSpaces';

export function createOnPasteAtCaret(setValue, currentText, maxWords) {
  return (event) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData('text');

    const current = currentText || '';
    const start = event.target.selectionStart ?? current.length;
    const end = event.target.selectionEnd ?? start;
    const before = current.slice(0, start);
    const after = current.slice(end);
    const combined = before + pastedData + after;

    const value = limitWordsAndSpaces(combined, maxWords);
    setValue(value);
  };
}

export default createOnPasteAtCaret;